import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';
import { DashboardLayout } from '@repo/ui/components/dashboard-layout';

const InventaireManagement = lazy(() =>
  import('@repo/ui/features/inventaires/not-validated/index').then((mod) => ({
    default: mod.InventaireManagement,
  })),
);

export default function NotValidatedPage() {
  return (

    <div className="w-full py-6">
      <Suspense fallback={<DendromapLoader message="Chargement des inventaires à valider..." />}>
        <InventaireManagement />
      </Suspense>
    </div>

  );
}

